import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";

// Layouts
import MainLayout from "../components/Layout/MainLayout";
import AuthLayout from "../components/Layout/AuthLayout";

// Outer Pages
import Login from "../pages/Login";
import Register from "../pages/Register";

// Dashboard Pages
import Dashboard from "../pages/Dashboard";

// Buy Packages
import BuyIco from "../pages/BuyPackages/BuyIco";
import PackageHistory from "../pages/BuyPackages/PackageHistory";

// My Affiliate
import DirectAffiliates from "../pages/MyAffiliate/DirectAffiliates";
import AllAffiliates from "../pages/MyAffiliate/AllAffiliates";

// My Earnings
import DirectBonus from "../pages/MyEarnings/DirectBonus";
import LevelBonus from "../pages/MyEarnings/LevelBonus";
import ROIBonus from "../pages/MyEarnings/ROIBonus";
import TotalROIBonus from "../pages/MyEarnings/TotalROIBonus";
import WeeklyBonusElegible from "../pages/MyEarnings/WeeklyBonusElegible";
import WeeklyBonus from "../pages/MyEarnings/WeeklyBonus";


// USDT Wallet
import USDTWalletStatement from "../pages/USDTWallet/WalletStatement";
import USDTRequestWithdrawal from "../pages/USDTWallet/RequestWithdrawal";
import USDTWithdrawalHistory from "../pages/USDTWallet/WithdrawalHistory";
// Token Wallet
/* import TokenWalletStatement from "../pages/TokenWallet/WalletStatement";
import TokenRequestWithdrawal from "../pages/TokenWallet/RequestWithdrawal";
import TokenWithdrawalHistory from "../pages/TokenWallet/WithdrawalHistory"; */



// Help
import CreateTicket from "../pages/Help/CreateTicket";
import TicketList from "../pages/Help/TicketList";
import Help from "../pages/Help/Help";

// Logout
import Logout from "../pages/Logout";


import ProtectedRoute from "../components/ProtectedRoute";

// ---------- Title Updater ----------
const CurrentPath = () => {
  const location = useLocation();
  useEffect(() => {
    switch (location.pathname) {
      case "/":
        document.title = "Login | Bitwavecapital";
        break;
      case "/register":
        document.title = "Register | Bitwavecapital";
        break;
      default:
        document.title = "Bitwavecapital";
    }
  }, [location]);

  return null;
};

// ---------- Router ----------
const Router = () => {
  return (
    <BrowserRouter>
      <CurrentPath />
      <Routes>
        {/* Auth Pages (No Header/Footer) */}
        <Route path="/" element={<AuthLayout><Login /></AuthLayout>} />
         <Route path="/login" element={<AuthLayout><Login /></AuthLayout>} />
        <Route path="/register" element={<AuthLayout><Register /></AuthLayout>} />
          
        {/* Main Pages (With Header/Footer) */}
        <Route
  path="/dashboard"
  element={
    <ProtectedRoute>
      <MainLayout>
        <Dashboard />
      </MainLayout>
    </ProtectedRoute>
  }
/>

        {/* Buy Packages */}

         <Route
  path="/ico-participation/Buy-Ico"
  element={
    <ProtectedRoute>
      <MainLayout><BuyIco/></MainLayout>
    </ProtectedRoute>
  }
/>


<Route
  path="/ico-participation/history"
  element={
    <ProtectedRoute>
      <MainLayout><PackageHistory /></MainLayout>
    </ProtectedRoute>
  }
/>

{/* My Affiliate */}
<Route
  path="/my-affiliate/direct"
  element={
    <ProtectedRoute>
      <MainLayout><DirectAffiliates /></MainLayout>
    </ProtectedRoute>
  }
/>
<Route
  path="/my-affiliate/all"
  element={
    <ProtectedRoute>
      <MainLayout><AllAffiliates /></MainLayout>
    </ProtectedRoute>
  }
/>

{/* My Earnings */}
<Route
  path="/my-earnings/direct-bonus"
  element={
    <ProtectedRoute>
      <MainLayout><DirectBonus /></MainLayout>
    </ProtectedRoute>
  }
/>
<Route
  path="/my-earnings/total-roi-bonus"
  element={
    <ProtectedRoute>
      <MainLayout><TotalROIBonus /></MainLayout>
    </ProtectedRoute>
  }
/>
<Route
  path="/my-earnings/roi-bonus"
  element={
    <ProtectedRoute>
      <MainLayout><ROIBonus /></MainLayout>
    </ProtectedRoute>
  }
/>
<Route
  path="/my-earnings/level-bonus"
  element={
    <ProtectedRoute>
      <MainLayout><LevelBonus /></MainLayout>
    </ProtectedRoute>
  }
  />
  <Route
  path="/my-earnings/weekly-bonus-elegible"
  element={
    <ProtectedRoute>
      <MainLayout><WeeklyBonusElegible /></MainLayout>
    </ProtectedRoute>
  }
/>
  <Route
  path="/my-earnings/weekly-bonus"
  element={
    <ProtectedRoute>
      <MainLayout><WeeklyBonus /></MainLayout>
    </ProtectedRoute>
  }
/>
{/* Token Wallet */}
 <Route
  path="/usdt-wallet/statement"
  element={
    <ProtectedRoute>
      <MainLayout><USDTWalletStatement /></MainLayout>
    </ProtectedRoute>
  }
/>
<Route
  path="/usdt-wallet/request-withdrawal"
  element={
    <ProtectedRoute>
      <MainLayout><USDTRequestWithdrawal /></MainLayout>
    </ProtectedRoute>
  }
/>
<Route
  path="/usdt-wallet/withdrawal-history"
  element={
    <ProtectedRoute>
      <MainLayout><USDTWithdrawalHistory /></MainLayout>
    </ProtectedRoute>
  }
/> 



{/* Help */}
<Route
  path="/help/create-ticket"
  element={
    <ProtectedRoute>
      <MainLayout><CreateTicket /></MainLayout>
    </ProtectedRoute>
  }
/>
<Route
  path="/help/tickets"
  element={
    <ProtectedRoute>
      <MainLayout><TicketList /></MainLayout>
    </ProtectedRoute>
  }
/>
<Route
  path="/help/Help"
  element={
    <ProtectedRoute>
      <MainLayout><Help /></MainLayout>
    </ProtectedRoute>
  }
/>


        {/* Logout */}
        <Route path="/logout" element={<MainLayout><Logout /></MainLayout>} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
